export enum StorageItem {
    AUTH_TOKEN = 'auth-token'
}
